import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table,Form,Input, Switch,Button } from 'antd'
import CreateFileMappingRow from './CreateFileMappingRow'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs:{span:24},sm:{span:16,offset: 8},md:{span:16,offset: 8},lg:{span:18,offset: 6}
    },
  };

export default class CreateFileMappingTable extends Component {
    static propTypes = {
        // prop: PropTypes
    }

    render() {
        return (
            <div>
                {this.props.tableData.map((el,index)=><CreateFileMappingRow
                  key={index}
                  bulk_source_file_name={el.bulk_source_file_name}
                  status={el.status}
                  index={index}
                  updateRecord={this.props.updateRecord}
                  removeRecord={this.props.removeRecord}
                  addRecord={this.props.addRecord}
                />)}
                <Form.Item {...formItemLayoutWithOutLabel}>
                    <Button type="dashed" onClick={this.props.addRecord} style={{ maxWidth: '320px' }}>
                    <PlusOutlined /> Add Bulk File
                    </Button>
                </Form.Item>
            </div>
        )
    }
}
